import React, { useEffect, useState } from 'react';
import { Button, Typography, Box, Skeleton } from '@mui/material';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';

const PODetails = () => {
  const { id } = useParams();
  const [po, setPo] = useState(null);

  useEffect(() => {
    const fetchPO = async () => {
      try {
        const response = await axios.get(`https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/pos/${id}`);
        setPo(response.data);
      } catch (error) { console.error('Error fetching PO:', error); }
    };
    fetchPO();
  }, [id]);

  const handleChangeStatus = async (newStatus) => {
    const t = toast.loading('Updating status…');
    try {
      await axios.put(`https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/pos/${id}`, { status: newStatus });
      setPo((prevPo) => ({ ...prevPo, status: newStatus }));
      toast.success(`Status updated to ${newStatus}`, { id: t });
    } catch (error) {
      console.error('Error updating PO status:', error);
      toast.error('Failed to update status', { id: t });
    }
  };

  if (!po) return (
    <Box sx={{ maxWidth: 560 }}>
      <Skeleton variant="text" width="35%" sx={{ fontSize: '2rem', mb: 3 }} />
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, mb: 3 }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Box key={i} sx={{
            display: 'flex', justifyContent: 'space-between', px: 2.5, py: 1.5,
            borderBottom: i === 4 ? 'none' : '1px solid', borderColor: 'divider',
          }}>
            <Skeleton variant="text" width="25%" />
            <Skeleton variant="text" width="40%" />
          </Box>
        ))}
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Skeleton variant="rectangular" width={110} height={32} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" width={110} height={32} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" width={110} height={32} sx={{ borderRadius: 1 }} />
      </Box>
    </Box>
  );

  return (
    <Box className="fade-in" sx={{ maxWidth: 560 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '-0.02em', mb: 3 }}>
        PO Details
      </Typography>

      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
        {[
          { label: 'Name', value: po.poName },
          { label: 'Platform', value: po.platform },
          { label: 'Status', value: po.status },
          { label: 'Order Date', value: po.orderDate ? new Date(po.orderDate).toLocaleDateString() : '-' },
          { label: 'Expected Delivery', value: po.expectedDeliveryDate ? new Date(po.expectedDeliveryDate).toLocaleDateString() : '-' },
        ].map((item, i) => (
          <Box key={i} sx={{
            display: 'flex', justifyContent: 'space-between', px: 2.5, py: 1.5,
            borderBottom: '1px solid', borderColor: 'divider',
            '&:last-child': { borderBottom: 'none' },
          }}>
            <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.04em', fontSize: '0.7rem' }}>
              {item.label}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>{item.value}</Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button variant="contained" size="small" onClick={() => handleChangeStatus('Ordered')}
          sx={{ bgcolor: '#2383e2', '&:hover': { bgcolor: '#1b6ec2' } }}>Mark Ordered</Button>
        <Button variant="outlined" size="small" color="success" onClick={() => handleChangeStatus('Received')}>Mark Received</Button>
        <Button variant="outlined" size="small" color="error" onClick={() => handleChangeStatus('Backordered')}>Backordered</Button>
      </Box>
    </Box>
  );
};

export default PODetails;
